const activityPage = {
  "activity.no-data.title": "Welcome to Be Your Best Pro",
  "activity.no-data.subtitle": "Start training in VR today and track your progress here.",
  "activity.hero.title": "Your Activity",
  "activity.hero.subtitle": "Every session tells part of your story, from training history to performance insights.",
  "activity.empty.title": "No completed sessions yet",
  "activity.empty.subtitle": "Finish a VR session and your results will appear here.",
  "activity.load-more": "Load more sessions",
};

const activityPageMobile = {
  "activity.latest.title": "Latest",
  "activity.journal.title": "Journal",
  "activity.journal.view-session": "View Session",
};

export const activity = {
  ...activityPage,
  ...activityPageMobile,
};
